export class UrlHelper {
  public static objectToUrlParams(object: any) {
    const params = new URLSearchParams();
    const obj = { ...object };

    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (value !== '' && value !== null) {
        params.append(key, value);
      }
    });

    return params.toString();
  }
}
